import { render, staticRenderFns } from "./Options.vue?vue&type=template&id=c2354e32&"
import script from "./Options.vue?vue&type=script&lang=ts&"
export * from "./Options.vue?vue&type=script&lang=ts&"
import style0 from "./Options.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports